import { ChevronRight, ImageIcon } from 'lucide-react';
import { Link } from 'react-router';
import { categoryLabel } from '@sf/shared';
import { CategoryIcon } from '../../components/CategoryIcon';
import { StatusBadge } from '../../components/StatusBadge';
import { UnreadDot } from '../../components/ui/Feedback';
import { formatDate, formatRelative } from '../../lib/format';
import type { Ticket } from '../../lib/types';

export function TicketListItem({
  ticket,
  to,
  unread,
  showTenant,
}: {
  ticket: Ticket;
  to: string;
  unread: number;
  showTenant?: boolean;
}) {
  return (
    <li>
      <Link
        to={to}
        className="flex items-center gap-3 rounded-card border border-stone bg-white p-4 shadow-card transition hover:-translate-y-px hover:shadow-md"
      >
        <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand">
          <CategoryIcon category={ticket.category} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="flex flex-wrap items-center gap-2">
            <span className="truncate font-medium text-ink">{ticket.title}</span>
            <StatusBadge kind="ticket" value={ticket.status} />
            <UnreadDot count={unread} />
          </span>
          <span className="mt-0.5 flex flex-wrap gap-x-3 text-xs text-slate">
            <span>{categoryLabel(ticket.category)}</span>
            {showTenant && (
              <span>
                Unit <span className="tabular-nums">{ticket.unitNumber}</span> · {ticket.tenantName}
              </span>
            )}
            <span className="tabular-nums">Raised {formatDate(ticket.createdAt)}</span>
            <span>Last activity {formatRelative(ticket.lastMessageAt)}</span>
            {ticket.imagePaths.length > 0 && (
              <span className="inline-flex items-center gap-1 tabular-nums">
                <ImageIcon className="size-3.5" aria-hidden />
                {ticket.imagePaths.length}
                <span className="sr-only">photos</span>
              </span>
            )}
          </span>
        </span>
        <ChevronRight className="size-5 shrink-0 text-slate" aria-hidden />
      </Link>
    </li>
  );
}
